import { Component, EventEmitter, Input, Output } from '@angular/core';
import { documentConfigs, documentDotStatusMap, documentStatusMap } from 'src/app/constants/documents.const';
import { DocumentConfigType } from 'src/app/models/documents.model';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/services/base.service';
import { DOC_STATE, PDF_CA, PDF_SLA } from 'src/app/constants/endpoint.const';
import { Subject, takeUntil } from 'rxjs';
import { ResponseCustomType } from 'src/app/types/response/response.type';
import { DocumentStateResponseType } from 'src/app/types/response/document-state.response.type';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  standalone: false,
  selector: 'app-qrisly-service-doc',
  templateUrl: './qrisly-service-doc.component.html',
  styleUrl: './qrisly-service-doc.component.scss'
})
export class QrislyServiceDocComponent {
  private destroy$ = new Subject<void>();
  @Input() docState: DocumentStateResponseType[] = [];
  @Output() stateUpdated = new EventEmitter<void>();
  docSLA: string = '';
  loading: boolean = true;
  documentConfigs: DocumentConfigType[] = documentConfigs.filter(item => item.type === 'SLA');

  constructor(
    private router: Router,
    private BaseService: BaseService,
    private message: NzMessageService
  ) {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

  handleAction(config: DocumentConfigType, mode: string) {
    const route = config.route + '-qrisly';
    const type = config.type;
    const queryParams: any = { service_type: 'qrisly' };

    if (type === 'SLA' || type === 'UAT') {
      queryParams.step = 1;
      localStorage.setItem(`mode-${type.toLowerCase()}-input-qrisly`, mode);
      localStorage.setItem('service_type_doc', 'qrisly');
    }

    if (mode === 'edit') {
      queryParams.mode = mode;
      localStorage.setItem(`mode-${type.toLowerCase()}-input-qrisly`, mode);
      localStorage.setItem('service_type_doc', 'qrisly');
    }

    this.router.navigate([route], { queryParams });
  }

  sendDoc(type: string) {
    const route = type === 'SLA' ? '/document/submission-sla-qrisly' : '/document/submission-ca-qrisly';
    this.router.navigate([route], { queryParams: { service_type: 'qrisly' } });
  }


  downloadPdf(v: string) {
    const url = v === 'SLA' ? PDF_SLA : PDF_CA;
    this.BaseService.getData(url + '?service_types_id=3')
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.docSLA = res.data.uploaded_file_path;
          window.open(this.docSLA, '_blank');
          this.updateState(v);
        },
        error: () => {
          this.message.error('The document is still in progress or has not been inputted yet');
        }
      });
  }

  getStateByType(type: string): DocumentStateResponseType | undefined {
    return this.docState.find((s) => s.document_type === type);
  }

  updateState(v: string): void {
    const params = {
      document_type: v,
      state: 3,
    };
    this.BaseService.putData(DOC_STATE + '?service_types_id=3', params)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.stateUpdated.emit();
        },
        error: (err) => {
          this.message.error(err.error.meta.message || 'Failed to update document state');
        }
      });
  }

  handleStatus(v: number | undefined) {
    return (v !== undefined && documentStatusMap[v]) || '';
  }

  handleDotStatus(v: number | undefined) {
    return (v !== undefined && documentDotStatusMap[v]) || '';
  }
}
